import { useGetCreatorTurnAroundTimeQuery } from "@/redux/feature/creatorTat/creatorTatApi";
import { useAppSelector } from "@/redux/hooks/hooks";
import InfoIcon from "@/assets/icons/InfoCircle.svg";

const CreatorTats = () => {
  const { user } = useAppSelector((state) => state.auth);
  const { data: turnAroundDTO } = useGetCreatorTurnAroundTimeQuery({
    email: user?.email as string,
  });

  return (
    <div className="bg-white rounded-xl border border-gray-200 px-6 py-6 w-full h-full flex flex-col justify-center gap-5">
      {/* Rating Row */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div className="flex items-center gap-3">
          <p className="text-xs font-semibold font-grotesk px-3 py-1.5 border border-[#B8B8B8] rounded-full text-[#444] tracking-wide uppercase">
            Ratings
          </p>
          <span className="text-4xl font-semibold text-[#202020] font-grotesk leading-none">
            {turnAroundDTO?.data?.totalProjectsCompleted ?? 0}
          </span>
        </div>
        <p className="text-xs text-[#9CA3AF] leading-5 sm:text-right">
          Creators with this turnaround typically handle{" "}
          <span className="text-[#FF6600] font-medium">
            {turnAroundDTO?.data?.totalProjectsCompleted ?? 0} projects monthly.
          </span>
        </p>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-100" />

      {/* TAT Row */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div className="flex items-center gap-3">
          <span className="text-xs font-semibold font-grotesk px-3 py-1.5 border border-[#B8B8B8] rounded-full text-[#444] tracking-wide uppercase flex items-center gap-1">
            TAT <InfoIcon />
          </span>
          <div className="flex items-center gap-2.5">
            <span className="text-4xl font-semibold text-[#202020] font-grotesk leading-none">
              {turnAroundDTO?.data?.averageCompletionDays ?? 0}
              <span className="text-xl font-medium text-[#202020] ml-1">
                Days
              </span>
            </span>
            <div className="bg-[#D9FBD0] rounded px-2.5 py-1 border border-[#BEE8B4]">
              <p className="text-[#1C6C09] text-[10px] font-semibold tracking-wide uppercase leading-none">
                Good
              </p>
            </div>
          </div>
        </div>
        <p className="text-xs text-[#9CA3AF] leading-5 sm:text-right">
          Creators with this turnaround typically handle{" "}
          <span className="text-[#FF6600] font-medium">
            {turnAroundDTO?.data?.totalProjectsCompleted ?? 0} projects monthly.
          </span>
        </p>
      </div>
    </div>
  );
};
export default CreatorTats;
